var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "person_svg__a",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h28v28H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#person_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M14 14q-1.925 0-3.296-1.37-1.37-1.372-1.37-3.297t1.37-3.295Q12.075 4.667 14 4.667t3.296 1.37q1.37 1.371 1.37 3.296 0 1.926-1.37 3.296Q15.925 14 14 14m-9.333 7v-.933q0-.992.51-1.823t1.356-1.269a17.3 17.3 0 0 1 3.675-1.356A16 16 0 0 1 14 15.167q1.925 0 3.792.452 1.867.451 3.675 1.356a3.4 3.4 0 0 1 1.356 1.269q.51.831.51 1.823V21q0 .963-.685 1.648a2.25 2.25 0 0 1-1.648.685H7a2.25 2.25 0 0 1-1.648-.685A2.25 2.25 0 0 1 4.667 21M7 21h14v-.933q0-.321-.16-.584a1.14 1.14 0 0 0-.423-.408 15.2 15.2 0 0 0-3.18-1.181 13.5 13.5 0 0 0-6.474 0q-1.605.393-3.18 1.181a1.14 1.14 0 0 0-.583.992zm7-9.333q.963 0 1.648-.686a2.25 2.25 0 0 0 .685-1.648q0-.962-.685-1.647A2.25 2.25 0 0 0 14 7q-.963 0-1.648.686a2.25 2.25 0 0 0-.685 1.647q0 .963.685 1.648a2.25 2.25 0 0 0 1.648.686"
  }))));
};
export default SvgPerson;